
<template>
  <div class="tf-vue-bg-grey-darker">
    <button 
      href="javascript:void(0)" 
      type="button"
      class="text-white text-decoration-none d-flex align-items-center justify-content-center w-100 h-100 p-2 btn btn-primary" 
      data-bs-toggle="modal" 
      data-bs-target="#annualPolicy"
      :disabled='premium === "0" || over90'
    >Buy
    </button>

    <div
      id="annualPolicy"
      class="modal"
      tabindex="-1"
      aria-labelledby="annualPolicyLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content p-4">
          <div class="container">
            <h4 class="text-center text-dark">Annual Multi-Trip Policy Check</h4>
            <div class="mt-5">
              <p class="text-dark fw-bold">
              Our Annual Multi-Trip policy for 2 or more people is only applicable to family groups. Policies must contain maximum 2 adults who must be live-together partners or spouses.
              Children 18 & under at date of payment are included free of charge and must be named on the policy. Children may travel independently of parents.
              </p>
            </div>
          </div>

        <div class="d-flex justify-content-center">
          <input
          type="checkbox"
          id="annual-terms"
          class="align-self-baseline"
          :value='true'
          v-model="annualCheck"
          />
          <p>I confirm I have read and understood this message and that I qualify for a Family Annual Multi-Trip policy.</p>
        </div>

        <div class="text-center mt-5">
          <button 
          class="btn btn-primary" 
          :disabled='!annualCheck'
          data-bs-dismiss="modal"
          @click="$emit('terms-accepted')"   
          >
            Continue
          </button>
        </div>

        <div class="text-center my-3">
          <button type="button" class="btn btn-outline-secondary" @click="setToFalse" data-bs-dismiss="modal">Cancel</button>
        </div>

        </div>
      </div> 
    </div>
  </div>
</template>


<script>
export default {
  props: ['over90','premium'],
  data() {
    return {
      annualCheck: false
    }
  },
  methods: {
    setToFalse() {
      this.annualCheck = false
    }
  }
}
</script>
<style scoped>
  #annual-terms {
    margin-right: 0.5rem;
  }
  .container {
    width: 100%;
  }
</style>